

define(['jquery', 'squid/index', 'text!./template.html', 'components/xo-models/src/checkout/index', 'components/xo-address-components/src/address-display/directive', 'components/xo-page-components/src/aside-header/directive', 'components/xo-tray-height/dist/directive', 'components/xo-ui-components/src/accessibility/directive'], function ($, squid, template) {

    squid.module('xo-select-shipping.xo-delete-shipping.directive', ['squid', 'xomodel.checkout', 'xo-address-display.directive', 'xo-aside-header.directive', 'xo-tray-height.directive', 'xo-accessibility.directive']).directive('xoDeleteShipping', function () {
        return {
            template: template,
            scope: {
                token: '=',
                sidebar: '='
            },
            controller: function controller($scope, $log, $populate, $state, $rootScope, $timeout, $CheckoutShippingAddressesModel) {

                var contingencyMapping = {
                    RISK_CHECK_FAILED: 'deleteShipping.genericError',
                    ADDRESS_ALREADY_REMOVED: 'deleteShipping.genericError',
                    ADDRESS_CANNOT_REMOVE_PRIMARY: 'deleteShipping.primaryOrBillingAddress',
                    ADDRESS_CANNOT_REMOVE_BILLING: 'deleteShipping.primaryOrBillingAddress',
                    ADDRESS_CANNOT_REMOVE_SELECTED: 'deleteShipping.selectedAddress',
                    ACCOUNT_NEGATIVE_BALANCE: 'deleteShipping.genericError',
                    ADDRESS_CANNOT_REMOVE: 'deleteShipping.genericError'
                };

                function isPrimaryOrSelected(address) {
                    return address.primary_address || address.default_address;
                }

                function removeAddress(address) {
                    $('#deleteShipping .address' + address.idx).addClass('collapse');
                    $timeout(function () {
                        $scope.checkoutShippingAddresses.addresses = $scope.checkoutShippingAddresses.addresses.filter(function (item) {
                            return item.id !== address.id;
                        });
                        $scope.$broadcast('addressUpdated');
                    }, 600);
                }

                $populate($scope, {
                    checkoutShippingAddresses: $CheckoutShippingAddressesModel.instance($scope.token)
                }).then(function () {
                    $scope.checkoutShippingAddresses.addresses.forEach(function (address, index) {
                        address.showDelete = address.isDeletable = !isPrimaryOrSelected(address);
                        address.idx = index;
                    });
                    $scope.$broadcast('addressUpdated');
                });

                $scope.backUrl = 'checkout.review.sidebar.shipping';

                // Return on modal cancel
                $scope.goBack = function () {
                    $state.go($scope.backUrl);
                };

                // Needed the three variables for animating buttons slide in/out
                $scope.onDelete = function (address) {
                    address.showConfirm = true;
                    $scope.checkoutShippingAddresses.addresses.filter(function (item) {
                        if (item.deleteClicked) {
                            $('#deleteShipping .address' + item.idx + ' .address').removeClass('slide');
                            $('#deleteShipping .address' + item.idx + ' .confirm').removeClass('slidein');
                            item.showDelete = true;
                            $timeout(function () {
                                item.deleteClicked = false;
                                item.showConfirm = false;
                                $('#deleteShipping .address' + item.idx + ' .delete:not(.confirm)').removeClass('slideOut');
                            }, 500);
                        }
                    });

                    address.deleteClicked = true;
                    $('#deleteShipping .address' + address.idx + ' .delete:not(.confirm)').addClass('slideOut');
                    $timeout(function () {
                        $('#deleteShipping .address' + address.idx + ' .confirm').addClass('slidein');
                        $('#deleteShipping .address' + address.idx + ' .address').addClass('slide');
                        address.showDelete = false;
                    });
                    // Focus the confirm link when it comes into view after the css animation
                    $timeout(function () {
                        $('#deleteShipping .address' + address.idx + ' .confirmBtn').focus();
                    }, 500);
                };

                $scope.showDelete = function (address) {
                    return address.isDeletable && address.showDelete;
                };

                $scope.showConfirmDelete = function (address) {
                    return address.isDeletable && address.showConfirm;
                };

                $scope.showInfoMsgIcon = function (address) {
                    return isPrimaryOrSelected(address) && !address.contingencyInfoMsgKey;
                };

                $scope.showInfoMessage = function (address) {
                    if (address.default_address) {
                        address.contingencyInfoMsgKey = contingencyMapping.ADDRESS_CANNOT_REMOVE_SELECTED;
                    } else if (address.primary_address) {
                        address.contingencyInfoMsgKey = contingencyMapping.ADDRESS_CANNOT_REMOVE_PRIMARY;
                    }
                    // Expand the info message and focus on the first delete link to keep focus within form
                    $timeout(function () {
                        $('#deleteShipping .address' + address.idx + ' .msg-inline').addClass('expand');
                        $('#deleteShipping .deleteBtn').first().focus();
                    });
                };

                $scope.onConfirmDelete = function (address) {
                    address.action('delete', {
                        success: function success() {
                            removeAddress(address);
                        },
                        contingencies: {
                            DEFAULT: function DEFAULT(name) {
                                if (name === 'ADDRESS_ALREADY_REMOVED') {
                                    removeAddress(address);
                                    return;
                                }

                                address.isDeletable = false;
                                address.contingencyErrorMsgKey = contingencyMapping[name] || contingencyMapping.ADDRESS_CANNOT_REMOVE;
                                $('#deleteShipping .address' + address.idx + ' .address').removeClass('slide');
                                $('#deleteShipping .address' + address.idx + ' .address').addClass('slideFast');
                                $timeout(function () {
                                    $('#deleteShipping .address' + address.idx + ' .msg-inline').addClass('expand');
                                }, 500);
                            }
                        }
                    });
                };

                // Provide watch value for modal-box and select-box to recalculate keyboard behavior based on number of infoMsgIcons and confirmLinks
                $scope.numModalElements = function () {
                    if (!$scope.checkoutShippingAddresses.addresses) {
                        return 0;
                    }
                    // Track messages by index, if they have flags active, seeing which flags they have active
                    return $scope.checkoutShippingAddresses.addresses.reduce(function (sum, address, index) {
                        var item = $scope.showInfoMsgIcon(address) || $scope.showConfirmDelete(address) ? index + 1 : 0;
                        return sum + item;
                    }, 0);
                };
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-member-components/src/select-shipping/delete-shipping/directive.js
 ** module id = 306
 ** module chunks = 1
 **/